<template>
  <div class="main">
    <GoBack :name="`我的消息`" :type="2" :path="`/mobile/my`"></GoBack>
    
    <!-- 筛选框 -->
    <div class="screen-box2">
      <div class="left">
        <el-select
          v-model="read2"
          placeholder="是否已读"
          clearable
          @change="getMessages2(1)"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="input-box">
        <input v-model="title2" placeholder="消息标题" />
        <img
          @click="getMessages2(1)"
          src="@/assets/image/module/search.png"
        />
      </div>
    </div>

    <!-- 列表 -->
    <div class="list-box" ref="scrollContainer" @scroll="handleScroll">
      <div class="list-item" v-for="(item, index) in tableData2" :key="index">
        <div class="line-box">
          <div class="title">消息标题</div>
          <div class="content">{{ item.Title }}</div>
        </div>

        <div class="line-box">
          <div class="title">发送时间</div>
          <div class="content">{{ item.SendTime | dateFrom }}</div>
        </div>

        <div class="line-box">
          <div class="title">是否已读</div>
          <div class="content color2">
            <div class="participationStatus" v-if="item.IsRead">
              <span style="background-color: #67c23a"></span>
              已读
            </div>
            <div class="participationStatus" v-else>
              <span style="background-color: #909399"></span>
              未读
            </div>
          </div>
        </div>
        <div class="line-box">
          <div class="title"></div>
          <div class="content-box">
            <div
              class="content color3"
              @click="sendMessages(item.ID, item.Content)"
            >
              查看
            </div>
            <div
              class="content color3 color4"
              @click="deleteMessages2(item.ID, index)"
            >
              删除
            </div>
          </div>
        </div>
      </div>

      <div class="flag" v-if="!flag && tableData2.length !== 0">
        触底加载更多
      </div>
      <div class="flag" v-if="flag && tableData2.length !== 0">
        已经到底了~
      </div>

      <el-empty
        v-if="tableData2.length === 0"
        description="暂无数据"
      ></el-empty>
    </div>

    <!-- 消息详情弹窗 -->
    <van-popup v-model="contentDialogVisible" position="bottom" :style="{ height: '60%' }">
      <div class="dialog-header">
        <div class="dialog-title">消息详情</div>
        <van-icon name="cross" @click="handleClose" />
      </div>
      <div class="dialog-content">
        <div v-html="content"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import GoBack from "@/components/goBack.vue";
import { getMessages, sendMessages, deleteMessages } from "@/api/mobile";

export default {
  filters: {
    dateFrom(data) {
      if (!data) return '';
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      options: [
        {
          value: true,
          label: "已读",
        },
        {
          value: false,
          label: "未读",
        },
      ],
      tableData2: [],
      page2: 1,
      size2: 10,
      title2: null,
      read2: null,
      flag: false,
      contentDialogVisible: false,
      content: null,
    };
  },
  components: {
    GoBack,
  },
  methods: {
    handleClose() {
      this.contentDialogVisible = false;
    },

    getMessages2(type) {
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }

      getMessages({
        page: this.page2,
        size: this.size2,
        read: this.read2,
        title: this.title2,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.tableData2 = this.tableData2.concat(res.data.list);
            if (res.data.list.length === 10) {
              this.page2++;
            } else {
              this.flag = true;
            }
          } else {
            this.flag = true;
          }
        }
      });
    },

    async sendMessages(id, content) {
      this.contentDialogVisible = true;
      this.content = content;
      sendMessages({ id }).then((res) => {
        if (res.code === 200) {
          this.getMessages2();
        }
      });
    },

    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 10
      ) {
        this.getMessages2();
      }
    },

    deleteMessages2(ID, index) {
      this.$dialog.confirm({
        message: "确认删除？删除后数据不可恢复",
      })
        .then(() => {
          const keys = [];
          keys.push(ID);
          deleteMessages({
            keys,
          }).then((res) => {
            if (res.code === 200) {
              this.$toast.success("删除成功");
              this.tableData2.splice(index, 1);
            }
          });
        })
        .catch(() => {
          // 取消删除
        });
    },
  },
  created() {
    if (this.$route.query.title) {
      this.title2 = this.$route.query.title;
    }
    this.getMessages2();
  },
};
</script>

<style lang="scss" scoped>
.flag {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 10px 0;
}

.main {
  min-height: 100vh;
  background-color: #f8f8fa;
  width: 100%;
  padding-bottom: 20px;

  // 筛选移动端
  .screen-box2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background-color: #fff;
    margin-bottom: 10px;

    .left {
      flex: 1;
      margin-right: 10px;

      ::v-deep .el-select {
        width: 100%;
      }
    }

    .input-box {
      position: relative;
      flex: 1;

      input {
        width: 100%;
        height: 40px;
        background: #ffffff;
        border-radius: 20px;
        padding: 0 42px 0 12px;
        border: 1px solid #eee;
        outline: none;
        box-sizing: border-box;
        font-size: 14px;
      }

      img {
        position: absolute;
        right: 12px;
        width: 20px;
        height: 20px;
        top: 10px;
        cursor: pointer;
      }
    }
  }

  // 列表移动端
  .list-box {
    padding: 0 15px;
    max-height: calc(100vh - 180px);
    overflow-y: auto;
    overflow-x: hidden;

    .list-item {
      width: 100%;
      background: #ffffff;
      border-radius: 4px;
      margin-bottom: 10px;
      padding: 17px 0;

      .line-box {
        padding: 0 15px 0 10px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #232323;
        margin-bottom: 12px;

        .title {
          font-size: 14px;
          color: #232323;
          flex-shrink: 0;
        }

        .content {
          flex: 1;
          text-align: right;
          word-break: break-all;
        }

        .color2 {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 14px;
          color: #474f66;

          .participationStatus {
            display: flex;
            align-items: center;

            span {
              width: 7px;
              height: 7px;
              border-radius: 3.5px;
              margin-right: 10px;
              display: inline-block;
            }
          }
        }

        .content-box {
          display: flex;
          justify-content: flex-end;
        }

        .color3 {
          font-size: 14px;
          color: #8846ff;
          cursor: pointer;
        }

        .color4 {
          margin-left: 15px;
        }
      }
    }
  }
}

// 弹窗样式
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #eee;

  .dialog-title {
    font-size: 16px;
    font-weight: bold;
    color: #232323;
  }

  ::v-deep .van-icon {
    font-size: 20px;
    cursor: pointer;
  }
}

.dialog-content {
  padding: 15px;
  height: calc(100% - 50px);
  overflow-y: auto;
  color: #474f66;
  font-size: 14px;
  line-height: 1.6;
}
</style>